import { BusinessMember, BusinessMemberApproval } from 'grow.client';

export const isBusinessMemberApproval = (member: BusinessMember | BusinessMemberApproval) : member is BusinessMemberApproval => {
    return (member as BusinessMemberApproval).createdByUserProfile !== undefined;
}